import React from "react";
import { Helmet } from "react-helmet-async";

interface IProps {
  /**Unique Google Tag ID */
  tagID: string;
  /**Overwrites the default page title that is displayed in the browser's tab `(optional)`*/
  title?: string;
}
/**
 * Sets up the required Google Analytic scripts within the <head> tag
 * @param {IProps} props
 * @param {string} props.tagID Unique Google Tag ID
 * @param {string} props.title The page title that is displayed in the browser's tab `(optional)`
 * @returns
 */
export default function GoogleAnalytics(props: IProps) {
  const { tagID, title } = props;
  return (
    <Helmet>
      {tagID && (
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${tagID}');`}
        </script>
      )}
      {title && <title>{title}</title>}
    </Helmet>
  );
}
